import React from 'react';

const renderKeyValueTable = (obj) => {
  if (!obj || typeof obj !== 'object') {
    return <p className="text-red-500">No data available.</p>;
  }

  return (
    <table className="w-full text-sm border mt-2 bg-white rounded shadow">
      <tbody>
        {Object.entries(obj).map(([key, value]) => (
          <tr key={key} className="border-b hover:bg-gray-50">
            <td className="p-2 font-medium bg-gray-50 border-r w-1/3 text-gray-700">{key}</td>
            <td className="p-2 text-gray-800">{value !== null && value !== undefined ? String(value) : '—'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const OrderDetailsCard = ({ order }) => {
  const order_data = {};
  const evaluation_tracker = {};
  const task_info = {};

  for (const [key, value] of Object.entries(order)) {
    if (
      key.startsWith("freelancer_") ||
      key === "task_id" ||
      key.startsWith("order_") ||
      key.startsWith("payout_") ||
      key === "due_date" ||
      key === "submitted_at" ||
      key === "submission_text"
    ) {
      order_data[key] = value;
    } else if (
      key.startsWith("cwe_") ||
      key.startsWith("evaluation_") ||
      key.endsWith("_evaluator_id") ||
      key.endsWith("_score") ||
      key === "approver_id"
    ) {
      evaluation_tracker[key] = value;
    } else {
      task_info[key] = value;
    }
  }

  return (
    <div className="bg-white p-6 border rounded-lg mt-4 shadow-sm space-y-6">
      <div className="flex flex-wrap space-x-6">
        {/* Order Data First */}
        <div className="flex-1 min-w-[300px]">
          <h3 className="text-lg font-semibold text-blue-700 mb-2 border-b pb-1">📦 Order Data</h3>
          {Object.keys(order_data).length > 0
            ? renderKeyValueTable(order_data)
            : <p className="text-gray-500">No data available.</p>}
        </div>

        {/* Task Info Second */}
        <div className="flex-1 min-w-[300px]">
          <h3 className="text-lg font-semibold text-green-700 mb-2 border-b pb-1">📚 Task Info</h3>
          {Object.keys(task_info).length > 0
            ? renderKeyValueTable(task_info)
            : <p className="text-gray-500">No data available.</p>}
        </div>

        {/* Evaluation Tracker Last */}
        <div className="flex-1 min-w-[300px]">
          <h3 className="text-lg font-semibold text-purple-700 mb-2 border-b pb-1">🧪 Evaluation Tracker</h3>
          {Object.keys(evaluation_tracker).length > 0
            ? renderKeyValueTable(evaluation_tracker)
            : <p className="text-gray-500">No data available.</p>}
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsCard;
